import styled from "styled-components";

import { PeriodButtonInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";

export const IconGraphicChange = styled.img`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 13px;
  height: 18px;
`

export const Container = styled.div`
    margin-top: 36px;
    width: 100%;
`;

export const GraficHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    height: 27px;
`
export const FilterLabel = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    line-height: 1;
    color: ${colors.tertiary};
    margin: 0px;
`;

export const DateContainer = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 100%;
    /* box-shadow: 0px 0px 5px ${colors.filterShadow}; */
    border-radius: 7px;
    /* margin-left: 15px; */
`

export const PeriodButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 63px;
    height: 21px;
    padding: 4px 0px;
    border: 1px solid ${colors.primary};
    border-radius: 5px;
    margin-left: 15px;
    background-color: ${(p: PeriodButtonInterface) => p.isActive ? colors.primary : colors.white};
    color: ${(p: PeriodButtonInterface) => p.isActive ? colors.white : colors.primary};

    &:focus{
        outline: 0;
    }
`;

export const PeriodButtonText = styled.p`
    line-height: 1;
    font: normal normal 600 10px Muli;
    margin: 0;
`;

export const FilterDateAndButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media(max-width: 768px){
    display: block;
  }
`

export const FilterDateConteiner = styled.div`
  display: flex;
  align-items: center;
  
  @media(max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
`;

export const PeriodButtonsContainer = styled.div`
  display: flex;
  align-items: center;

  .szh-menu-button {
    background: transparent;
    border: none;
    color: ${(p: PeriodButtonInterface) => p.isActive ? colors.white : colors.primary};
    display: flex;
    justify-content: center;
    align-items: center;
    outline: 0;
  }

  .szh-menu__item {
    font: normal normal 600 10px Muli;
  }

  .szh-menu__submenu {
    font: normal normal 600 10px Muli;
  }
  
  @media(max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
  }
`;
